module.exports = __webpack_public_path__ + "img/tooltip.e5bb1899.svg";